/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({ organizationId: ZodTypes.Id });

export const DeleteOrganizationRegistrationInvitation = {
  id: 'organization-registration-invitation.delete',
  tag: 'Organization',
  summary: 'Delete organization registration invitation',
  description: 'Cancel a registration invitation of an organization',
  method: 'delete',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) => `/organization/${params.organizationId}/user/registration-invitation`,
  request: {
    params: Params,
    query: z.strictObject({ email: ZodTypes.Base64 }),
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
